<!--声光报警-->
<template>
  <el-form label-width="100px" class="pd-10" :model="form">
    <el-row>
      <ConfigBase
        :row-data="rowData"
        :sensor-config="sensorConfig"
      ></ConfigBase>
      <!--      报警级别-->
      <el-col :span="colSpan">
        <el-form-item :label="$t('报警级别')" prop="alarmLevel">
          <el-select
            v-if="isEdit"
            v-model="form.alarmLevel"
            class="input-width"
          >
            <el-option
              :label="$t(value.title)"
              :value="parseInt(key)"
              v-for="(value, key) in fourGSensorAlarmLevel"
              :key="key"
            ></el-option>
          </el-select>
          <Modify
            v-else-if="jsonContent"
            :item="jsonContent.item.alarm_level"
            :mapper="fourGSensorAlarmLevel"
          ></Modify>
        </el-form-item>
      </el-col>

      <template v-if="form.alarmLevel !== 0">
        <!--      报警次数-->
        <el-col :span="colSpan">
          <el-form-item :label="$t('报警次数')" prop="alarmCycle">
            <el-input
              v-if="isEdit"
              v-model="form.alarmCycle"
              class="input-width"
            ></el-input>

            <Modify
              v-else-if="jsonContent"
              :item="jsonContent.item.alarm_cycle"
            >
            </Modify>
          </el-form-item>
        </el-col>
        <!--        报警间隔-->
        <el-col :span="colSpan">
          <el-form-item :label="$t('报警间隔')" prop="alarmInterval">
            <el-input
              v-model="form.alarmInterval"
              class="input-width"
              v-if="isEdit"
            ></el-input>
            <Modify
              v-else-if="jsonContent"
              :item="jsonContent.item.alarm_interval"
            >
            </Modify>
          </el-form-item>
        </el-col>
        <!--        报警持续时间-->
        <el-col :span="colSpan">
          <el-form-item :label="$t('报警持续时间')" prop="alarmDuration">
            <el-input
              v-model="form.alarmDuration"
              class="input-width"
              v-if="isEdit"
            ></el-input>
            <Modify
              v-else-if="jsonContent"
              :item="jsonContent.item.alarm_duration"
            >
            </Modify>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row class="uk-position-relative">
      <el-form-item
        :label="$t('public.command')"
        label-width="100px"
        v-if="jsonContent.cmd"
      >
        <span>{{ jsonContent.cmd }}</span>
      </el-form-item>
      <div style="position: absolute;right: 0;top:0" v-if="rowData">
        <el-button type="primary" @click="isEdit = true" v-if="!isEdit">
          {{ $t('配置') }}
        </el-button>
        <el-button @click="isEdit = false" v-else>
          {{ $t('取消') }}
        </el-button>

        <el-button v-if="isEdit" type="primary" @click="confirm"
          >{{ $t('确定') }}
        </el-button>
      </div>
    </el-row>

    <el-divider v-if="rowData"></el-divider>
    <ConfigList :sensor-info="rowData" :list="configList"></ConfigList>
  </el-form>
</template>

<script>
import { fourGSensorAlarmLevel } from '@/utils/dict/sensor'
import {
  sensorGetDetailConfig,
  updateSoundLightAlarmConfig
} from '@/api/modules/sensor'
import Modify from '@/pages/equipment/gateway/modal/ConfigDialog/GenTwo/component/Modify.vue'
import { transformEditSensorConfig } from '@/utils/transform/sensorTransForm'
import { soundLightAlarmConfigDefault } from '@/pages/equipment/sensor/components/sensor/cionfig/4GTempTab/default'
import ConfigBase from '@/pages/equipment/sensor/components/sensor/cionfig/ConfigBase.vue'

import ConfigList from '@/pages/equipment/sensor/components/sensor/cionfig/children/ConfigList.vue'

export default {
  name: 'SoundLightAlarm',
  components: {
    ConfigList,
    ConfigBase,
    Modify
  },
  props: ['rowData'],
  computed: {
    fourGSensorAlarmLevel () {
      return fourGSensorAlarmLevel
    },
    colSpan () {
      if (this.rowData) {
        return 12
      } else {
        return 24
      }
    }
  },
  data () {
    return {
      form: {
        idList: [],
        type: 0,
        ...soundLightAlarmConfigDefault
      },
      jsonContent: {
        item: {}
      },
      isEdit: false,
      configList: [],
      sensorConfig: null
    }
  },

  methods: {
    confirm () {
      this.form.idList = [this.rowData.id]
      this.form.type = this.rowData.type
      updateSoundLightAlarmConfig(this.form).then(({ result }) => {
        if (result) {
          this.$message.success('保存成功')
          this.isEdit = false
          this.getConfig()
        }
      })
    },
    getConfig () {
      if (!this.rowData) {
        return
      }
      // eslint-disable-next-line camelcase
      const { id, tag_id } = this.rowData
      sensorGetDetailConfig(
        {
          sensorId: id,
          tagId: tag_id
        },
        'alarm'
      ).then(({ result }) => {
        if (result.sensorConfig) {
          this.sensorConfig = result.sensorConfig

          this.jsonContent = JSON.parse(this.sensorConfig.content)
          this.form = transformEditSensorConfig(this.jsonContent.item)
          // 配置历史列表
          this.configList = this.sensorConfig.responseDeviceConfigLogList

          if (this.sensorConfig) {
            this.$emit('onConfigStatusChange', this.sensorConfig.status)
          }
        }
      })
    },
    // 根据服务器返回的数据(含有modify的Object类型对象)设置form值
    // 该函数给外部调用
    setData (config) {
      this.jsonContent.item = config
      this.form = { ...this.form, ...transformEditSensorConfig(config) }
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>
